import { render, staticRenderFns } from "./edit_diffusion.vue?vue&type=template&id=566bc770&scoped=true&"
import script from "./edit_diffusion.vue?vue&type=script&lang=js&"
export * from "./edit_diffusion.vue?vue&type=script&lang=js&"
import style0 from "./edit_diffusion.vue?vue&type=style&index=0&id=566bc770&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566bc770",
  null
  
)

export default component.exports